import React, { useState } from 'react';
import './Bookingtabel.css';

const STATUS_STYLES = {
  confirmed: 'badge badge--confirmed',
  pending:   'badge badge--pending',
  cancelled: 'badge badge--cancelled',
  paid:      'badge badge--confirmed',
  unpaid:    'badge badge--pending',
  refunded:  'badge badge--cancelled',
};

export const StatusBadge = ({ value }) => {
  const normalized = String(value ?? '').toLowerCase();
  return (
    <span className={STATUS_STYLES[normalized] || 'badge badge--default'}>
      {value ?? '—'}
    </span>
  );
};

const BookingTable = ({
  columns = [],
  data = [],
  emptyText = 'No records found.',
}) => {
  const [search, setSearch] = useState('');
  const [page, setPage]     = useState(1);
  const rowsPerPage         = 10;

  /* ── Search ── */
  const filtered = data.filter((row) =>
    columns.some((col) => {
      const val = row[col.key];
      return val != null && String(val).toLowerCase().includes(search.toLowerCase());
    })
  );

  /* ── Paginate ── */
  const totalPages = Math.max(1, Math.ceil(filtered.length / rowsPerPage));
  const safePage   = Math.min(page, totalPages);
  const paged      = filtered.slice((safePage - 1) * rowsPerPage, safePage * rowsPerPage);

  return (
    <div className='bt-wrapper'>
      {/* ── Search bar ── */}
      <div className='bt-controls'>
        <div className='bt-search-wrap'>
          <svg className='bt-search-icon' viewBox='0 0 20 20' fill='none'>
            <circle cx='9' cy='9' r='6' stroke='currentColor' strokeWidth='1.6'/>
            <path d='M14 14l3 3' stroke='currentColor' strokeWidth='1.6' strokeLinecap='round'/>
          </svg>
          <input
            className='bt-search'
            type='text'
            placeholder='Search bookings…'
            value={search}
            onChange={(e) => { setSearch(e.target.value); setPage(1); }}
          />
        </div>
      </div>

      {/* ── Table ── */}
      <div className='bt-scroll'>
        <table className='bt-table'>
          <thead>
            <tr>
              {columns.map((col) => (
                <th key={col.key} className='bt-th'>
                  {col.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {paged.length === 0 ? (
              <tr>
                <td colSpan={columns.length} className='bt-empty'>
                  {emptyText}
                </td>
              </tr>
            ) : (
              paged.map((row, idx) => (
                <tr key={row.id ?? idx} className='bt-tr'>
                  {columns.map((col) => (
                    <td key={col.key} className='bt-td'>
                      {col.render
                        ? col.render(row[col.key], row)
                        : row[col.key] ?? '—'}
                    </td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* ── Pagination ── */}
      <div className='bt-pagination'>
        <span className='bt-count'>
          {filtered.length === 0
            ? '0 records'
            : `${(safePage - 1) * rowsPerPage + 1}–${Math.min(safePage * rowsPerPage, filtered.length)} of ${filtered.length}`}
        </span>
        <div className='bt-pages'>
          <button className='bt-page-btn' disabled={safePage === 1} onClick={() => setPage(1)}>«</button>
          <button className='bt-page-btn' disabled={safePage === 1} onClick={() => setPage((p) => p - 1)}>‹</button>
          {Array.from({ length: totalPages }, (_, i) => i + 1)
            .filter((p) => Math.abs(p - safePage) <= 2)
            .map((p) => (
              <button
                key={p}
                className={`bt-page-btn ${p === safePage ? 'bt-page-btn--active' : ''}`}
                onClick={() => setPage(p)}
              >{p}</button>
            ))}
          <button className='bt-page-btn' disabled={safePage === totalPages} onClick={() => setPage((p) => p + 1)}>›</button>
          <button className='bt-page-btn' disabled={safePage === totalPages} onClick={() => setPage(totalPages)}>»</button>
        </div>
      </div>
    </div>
  );
};

export default BookingTable;